import { render } from "./LocalRoute.vue?vue&type=template&id=c3588d2a&scoped=true"
import script from "./LocalRoute.vue?vue&type=script&lang=js"
export * from "./LocalRoute.vue?vue&type=script&lang=js"

import "./LocalRoute.vue?vue&type=style&index=0&id=c3588d2a&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3588d2a"]])

export default __exports__